/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStretching = createReactComponent("stretching", "IconStretching", [
  ["path", { d: "M16 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-0" }],
  ["path", { d: "M5 20l5 -.5l1 -2", key: "svg-1" }],
  ["path", { d: "M18 20v-5h-5.5l2.5 -6.5l-5.5 1l1.5 2", key: "svg-2" }]
]);

export { IconStretching as default };
//# sourceMappingURL=IconStretching.js.map
